const musicData = [
    {
        cover: "https://lh3.googleusercontent.com/zdGQkuWBg60EHxsf5gEDWrSKcR1cdWkQ6LaJBHiWW9UHR2S5lslAjAWw8Yv8pzZH4AjStrEBTrmkG9scdQ=w544-h544-l90-rj",
        releaseYear: "2022",
        name: "2020",
        links: [
            {
                type:"spotify",
                link: "https://open.spotify.com/album/0oDG17C7f6tsnOg334qrfq"
            },
            {
                type:"youtube",
                link:"https://music.youtube.com/watch?v=MTtCT1F7EwA&list=OLAK5uy_k3ELi4EMHa-aXXa6qj_ViEQqClNsiwNZg"
            }
        ]
    },
    {
        cover: "https://lh3.googleusercontent.com/K3PY1tGnovsQGFkNvaHlNdd_SXYVhIH3zyiCBakAFdooTfVal6AIlNKQRRmiTQGw5QwMEuKcur4z5bfz=w544-h544-l90-rj",
        releaseYear: "2021",
        name: "Город",
        links: [
            {
                type:"spotify",
                link: "https://open.spotify.com/album/5pEPPJNbFIHJsK45oVsh4W"
            },
            {
                type:"youtube",
                link:"https://music.youtube.com/watch?v=xZRLFfOvr9w&list=RDAMVMxZRLFfOvr9w"
            }
        ]
    },
]
export default musicData